import { create } from 'zustand';

import { StagePrompt } from '@/types/general-settings/stage.prompt.type';

export interface StagePromptsState {
  stagePrompts: Array<StagePrompt> | undefined;
  setStagePrompts: (stagePrompts: Array<StagePrompt>) => void;
}

const useStagePromptsStore = create<StagePromptsState>((set) => ({
  stagePrompts: undefined,
  setStagePrompts: (stagePrompts: Array<StagePrompt>) =>
    set(() => ({ stagePrompts })),
}));

export { useStagePromptsStore };
